import { render, staticRenderFns } from "./MNManagementTemplate.vue?vue&type=template&id=ef35c43e&"
import script from "./MNManagementTemplate.vue?vue&type=script&lang=ts&"
export * from "./MNManagementTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports